import {Component, HostBinding, Injector, OnInit} from '@angular/core';
import {EventsComponent} from '../../../general/events/events.component';

@Component({
  selector: 'app-discount-checkbox',
  templateUrl: './discount-checkbox.component.html',
  styleUrls: ['./discount-checkbox.component.scss']
})
export class DiscountCheckboxComponent extends EventsComponent implements OnInit {
  @HostBinding("attr.name")
  name = this.control ? this.control.name : "";
  viewValue;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    if (this.value !== null && this.value !== '' && this.value !== false) {
      this.viewValue = true;
    }
    this.gaLabel = this.getGaLabel(this.control);
    if(this.value){
      this.reportPrefill();
    }
  }

  toggle(event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      this.viewValue = !this.viewValue;
      this.onChange();
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  }

  onChange() {
    let valueToSet;
    if (this.viewValue) {
      valueToSet = this.control.attributes.altValue != null ? this.control.attributes.altValue : this.viewValue;
    } else {
      valueToSet = this.control.attributes.altValue != null ? "" : this.viewValue;
    }
    this.splunkAnalyticsService.publish("CheckboxChange", this.control.attributes.title, valueToSet);
    this.setAnswer(valueToSet);
    this.reportEditedPrefillValue();
    this.elementRef.nativeElement
      .querySelectorAll("label span")[0]
      .classList.toggle("checked");
  }

}
